import GlobalSettingsAPI from "@/api/global-settings.api"

const XYZ_SETTING = "XYZ"

const state = {
  xyz: false
}

const actions = {
  // example of fetching global setting XYZ from API
  async getXYZSetting({ commit }) {
    const response = await GlobalSettingsAPI.getBoolSettingValue({ settingId: XYZ_SETTING })
    commit('SET_XYZ', Boolean(response.data))
    return response.data
  },
}

const mutations = {
  SET_XYZ(state, data) {
    state.xyz = data
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}  